<template>
  <!-- FT-079: post-login подсказка «добавьте passkey». Показ решает shouldShowNudge (per-device). -->
  <v-bottom-sheet v-model="show" :retain-focus="false" max-width="500">
    <v-sheet class="pa-6 text-center passkey-nudge">
      <div class="passkey-nudge-ico mx-auto mb-4">
        <v-icon size="34" color="primary">mdi-fingerprint</v-icon>
      </div>
      <div class="text-h6 font-weight-medium mb-1">{{ $t("passkey_nudge.title") }}</div>
      <div class="text-body-2 text--secondary mb-5">{{ $t("passkey_nudge.subtitle") }}</div>
      <v-btn block color="primary" large :loading="passkeyRegistering" @click="onAdd">
        <v-icon left>mdi-key-plus</v-icon>{{ $t("passkey_nudge.add") }}
      </v-btn>
      <v-btn block text class="mt-2" :disabled="passkeyRegistering" @click="onLater">
        {{ $t("passkey_nudge.later") }}
      </v-btn>
      <v-btn block text x-small class="mt-1 text--secondary" :disabled="passkeyRegistering" @click="onDontAsk">
        {{ $t("passkey_nudge.dont_ask") }}
      </v-btn>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import passkeyEnroll from "@/mixins/passkeyEnroll";
import { shouldShowNudge, markNudgeShown, markDismissedForever } from "@/utils/passkeyNudge";

const SESSION_SHOWN = "passkey_nudge_session_shown";
const LAST_METHOD = "passkey_last_login_method"; // ставит Signin на успехе логина

export default {
  name: "PasskeyNudge",
  mixins: [passkeyEnroll],
  data() {
    return { show: false };
  },
  computed: {
    // Завязываемся на currentUserId (а не isLoggedIn): он truthy только после загрузки пользователя
    // → в maybeShow гарантированно есть userId для per-account скоупинга состояния nudge.
    currentUserId() {
      return this.$store.getters.currentUserId;
    },
  },
  watch: {
    // Пользователь загружен (fresh login / рехидрация) → пробуем показать.
    currentUserId(val) {
      if (val) this.maybeShow();
    },
  },
  mounted() {
    // Если пользователь уже загружен до монтирования (редирект после fresh-login) — тоже проверяем.
    if (this.currentUserId) this.maybeShow();
  },
  methods: {
    sessionAlreadyShown() {
      try { return sessionStorage.getItem(SESSION_SHOWN) === "1"; } catch { return false; }
    },
    lastLoginMethod() {
      try { return sessionStorage.getItem(LAST_METHOD); } catch { return null; }
    },
    async maybeShow() {
      if (this.show) return;
      // Нет свежего логина в этой сессии (напр. перезагрузка по cookie) → не навязываемся.
      const method = this.lastLoginMethod();
      if (!method) return;
      // Не поверх формы логина: currentUserId появляется раньше, чем роутер
      // уводит с /signin — ждём редиректа и даём осмотреться пару секунд.
      if (this.$route && String(this.$route.path).startsWith("/signin")) {
        const unwatch = this.$watch("$route.path", (p) => {
          if (!String(p).startsWith("/signin")) {
            unwatch();
            this.maybeShow();
          }
        });
        return;
      }
      await new Promise((r) => setTimeout(r, 2500));
      if (this.show) return;
      await this.checkPasskeySupport();
      const ok = shouldShowNudge({
        platformAvailable: this.passkeyPlatformAvailable,
        lastLoginMethod: method,
        sessionShown: this.sessionAlreadyShown(),
        userId: this.currentUserId,
      });
      if (!ok) return;
      this.show = true;
      markNudgeShown(this.currentUserId);
      try { sessionStorage.setItem(SESSION_SHOWN, "1"); } catch { /* ignore */ }
    },
    async onAdd() {
      const ok = await this.enrollPasskey(); // на успехе миксин ставит enrolledHere
      if (ok) this.show = false;
    },
    onLater() {
      this.show = false;
    },
    onDontAsk() {
      markDismissedForever(this.currentUserId);
      this.show = false;
    },
  },
};
</script>

<style scoped>
.passkey-nudge-ico {
  width: 64px;
  height: 64px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(25, 118, 210, 0.14);
}
</style>
